import { render, staticRenderFns } from "./LanguageAwareStringInput.vue?vue&type=template&id=eaf64172&scoped=true&"
import script from "./LanguageAwareStringInput.vue?vue&type=script&lang=js&"
export * from "./LanguageAwareStringInput.vue?vue&type=script&lang=js&"
import style0 from "./LanguageAwareStringInput.vue?vue&type=style&index=0&id=eaf64172&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaf64172",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eaf64172')) {
      api.createRecord('eaf64172', component.options)
    } else {
      api.reload('eaf64172', component.options)
    }
    module.hot.accept("./LanguageAwareStringInput.vue?vue&type=template&id=eaf64172&scoped=true&", function () {
      api.rerender('eaf64172', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/form-input/LanguageAwareStringInput.vue"
export default component.exports